<app-feeds-live-sale-card *ngIf="isFeed" [liveSaleList]="liveSaleList"></app-feeds-live-sale-card>
<app-feed-create-post *ngIf="isFeed"  (postCreated)="postCreatedSuccess()"></app-feed-create-post>
<div *ngFor="let feed of feedsList">
  <app-feeds-blogs-list-card *ngIf="feed?.layout == POST_LAYOUTS?.ENTRACKR_BLOG"
    [blog]="feed"></app-feeds-blogs-list-card>
  <app-feeds-user-post-card [userPost]="feed" *ngIf="feed?.layout == POST_LAYOUTS?.USER_POST"></app-feeds-user-post-card>
  <app-feeds-creative-card [creative]="feed"
    *ngIf="feed?.layout == POST_LAYOUTS?.CREATIVE_POST"></app-feeds-creative-card>
  <app-feeds-company-carousel-card [companyList]="feed.list"
    *ngIf="feed?.layout == POST_LAYOUTS?.COMPANY_CAROUSEL"></app-feeds-company-carousel-card>
  <!-- <app-feeds-marketing-card ></app-feeds-marketing-card> -->
  <app-feeds-probo-card [probo]="feed" *ngIf="feed?.layout == POST_LAYOUTS?.PROBO_POST"></app-feeds-probo-card>
  <!-- <app-feeds-custom-report-card></app-feeds-custom-report-card> -->
  <app-feeds-subscribe-card *ngIf="feed?.layout == POST_LAYOUTS?.SUBSCRIBE && plan !== 'plan_premium' "></app-feeds-subscribe-card>
  <!-- <app-feeds-buy-subscription-card></app-feeds-buy-subscription-card> -->
  <app-subscribe-form-component *ngIf="feed?.layout == POST_LAYOUTS?.HAVE_A_QUERY"></app-subscribe-form-component>
</div>
